<template>
  <section id="about" class="py-16 md:py-24 px-6 md:px-12 lg:px-24">
    <h2 class="text-5xl md:text-6xl lg:text-5xl font-black text-[#39ab58] text-center mb-12">
      {{ $t('about.title') }}
    </h2>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <!-- Mission & Vision Section -->
      <div class="space-y-8" :class="{ 'order-2 md:order-none': $i18n.locale === 'ar' }">
        <!-- Mission -->
        <div
          class="bg-white p-8 shadow-lg rounded-lg border-2 border-[#9cbbe2] transition-all duration-300 hover:ring-1 ring-[#22c55e]">
          <h3 class="text-3xl font-bold text-[#346BB3] mb-4">{{ $t('about.mission.title') }}</h3>
          <p class="text-lg text-gray-700">
            {{ $t('about.mission.description') }}
          </p>
        </div>

        <!-- Vision -->
        <div
          class="bg-white p-8 shadow-lg rounded-lg border-2 border-[#9cbbe2] transition-all duration-300 hover:ring-1 ring-[#22c55e]">
          <h3 class="text-3xl font-bold text-[#346BB3] mb-4">{{ $t('about.vision.title') }}</h3>
          <p class="text-lg text-gray-700">
            {{ $t('about.vision.description') }}
          </p>
        </div>
      </div>

      <!-- Core Values -->
      <div
        class="bg-white p-8 shadow-lg rounded-lg border-2 border-[#9cbbe2] transition-all duration-300 hover:ring-1 ring-[#22c55e]"
        :class="{ 'order-1 md:order-none': $i18n.locale === 'ar' }">
        <h3 class="text-3xl font-bold text-[#346BB3] mb-6">{{ $t('about.values.title') }}</h3>
        <ul class="text-base/7 pl-8 text-lg text-gray-700" :class="{ 'pr-8 pl-0': $i18n.locale === 'ar' }">
          <template v-for="(value, index) in values" :key="index">
            <li>
              <bold class="text-[#346BB3]">{{ $t(value.title) }}</bold>
            </li>
            <li>{{ $t(value.description) }}</li>
          </template>
        </ul>
      </div>
    </div>
  </section>

  <div class="hidden md:block self-stretch divider-gradient mt-12"></div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      values: [
        {
          title: 'about.values.items.accuracy.title',
          description: 'about.values.items.accuracy.description'
        },
        {
          title: 'about.values.items.reliability.title',
          description: 'about.values.items.reliability.description'
        },
        {
          title: 'about.values.items.innovation.title',
          description: 'about.values.items.innovation.description'
        },
        {
          title: 'about.values.items.safety.title',
          description: 'about.values.items.safety.description'
        },
        {
          title: 'about.values.items.customerCentric.title',
          description: 'about.values.items.customerCentric.description'
        }
      ]
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;900&display=swap');

[dir="ltr"] h2,
[dir="ltr"] h3,
[dir="ltr"] p,
[dir="ltr"] span,
[dir="ltr"] li {
  font-family: "Poppins", sans-serif;
}

[dir="rtl"] h2,
[dir="rtl"] h3,
[dir="rtl"] p,
[dir="rtl"] span,
[dir="rtl"] li {
  font-family: "Cairo", sans-serif;
}

.divider-gradient {
  height: 22px;
  background: linear-gradient(90deg,
      rgba(162, 205, 222, 0) 0%,
      rgba(162, 205, 222, 1) 20%,
      rgba(215, 234, 236, 1) 49%,
      rgba(195, 230, 205, 1) 75%,
      rgba(195, 230, 205, 0) 100%,
      rgba(214, 234, 238, 1) 753%);
  width: 70%;
  margin: 0 auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  filter: blur(3px);
}

[dir="rtl"] .divider-gradient {
  transform: scaleX(-1);
}

h3 {
  position: relative;
  color: #346BB3;
  text-decoration: none;
  display: inline-block;
}

h3::before {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 2px;
  bottom: -5px;
  left: 0;
  background-color: #346BB3;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

[dir="rtl"] h3::before {
  left: auto;
  right: 0;
}

h3:hover::before {
  transform: scaleX(1);
}

@media (max-width: 768px) {
  .divider-gradient {
    display: block;
  }
}
</style>